import { from } from "rxjs";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { IdCharacterHelpType } from "../../../character-help-dialog/IdCharacterHelpType";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingUpgradeCharacterHelpMissingWorker = function (action$, state$) {
    var state = state$.value;
    var building = action$.building;
    var upgradeInfo = selectBuildingUpgradeInfo(building);
    var availableWorkers = state.baseInfo.maxWorkers
        ? state.baseInfo.maxWorkers - (state.baseInfo.usedWorkers || 0)
        : 0;
    var requiredWorkerCount = upgradeInfo.currentStage.workers - upgradeInfo.nextStage.workers;
    var missingWorker = requiredWorkerCount - availableWorkers;
    return from([
        actionOngoingPurchaseCharacterHelpSelect({
            missing: missingWorker.toString(),
            type: IdCharacterHelpType.MissingWorkers,
        }),
        actionModalOpen(IdModal.CharacterHelp),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingUpgradeCharacterHelpMissingWorker.ts
// module id = 2078
// module chunks = 3